import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import CustomChip from "../CustomChip";
import { CustomListSubheader } from "../CustomListSubheader";
import type { SectionHeader as SectionHeaderType } from "./types";

type Props = SectionHeaderType & {
	appFont: string;
};

export const SectionHeader = ({ appFont, title, chip }: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	return (
		<Box
			justifyContent="space-between"
			alignItems="center"
			flexDirection="row"
			paddingTop={isMobile ? 16 : 24}
		>
			<CustomListSubheader
				font={appFont}
				enableGutters={isMobile}
				style={{
					paddingBottom: isMobile ? 8 : 12,
				}}
			>
				{title}
			</CustomListSubheader>
			{chip ? (
				<CustomChip
					onPress={chip.onPress}
					icon={chip.icon}
					style={{
						backgroundColor: chip.background,
					}}
					textStyle={{
						color: theme.colors.onSurface,
					}}
				>
					{chip.label}
				</CustomChip>
			) : null}
		</Box>
	);
};
